import { Link } from "react-router-dom";

export default function Enrolled() {
  return (
    <div className="mx-auto max-w-2xl p-8 text-center">
      <h1 className="text-2xl font-bold text-green-700">You're enrolled</h1>
      <p className="mt-3 text-gray-600">
        Payment received. Your seat in the cohort is confirmed and you'll get course
        access details by email shortly.
      </p>
      <p className="mt-2 text-sm text-gray-500">
        If you don't see a confirmation within a few minutes, check your spam folder.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block rounded bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-700"
      >
        Back to cohorts
      </Link>
    </div>
  );
}
